// extracted by mini-css-extract-plugin
module.exports = {"StatusWrapper":"AssignStatus__StatusWrapper___2vIJS"};